export {
    FINISHED_ACTIVITY_TEXTS,
    StudentFinishedActivityPage,
    type StudentFinishedActivityPageProps,
    type StudentFinishedCorrection,
} from "./StudentFinishedActivityPage"
